import React from 'react';
import { FormattedDate } from 'react-intl';

export const PublishRequestDate = ({ value }: { value: string }) => (
  <FormattedDate value={value} year="numeric" month="short" day="numeric" hour="numeric" minute="2-digit" />
);
